import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { FarmMapPageRoutingModule } from './farm-map-routing.module';

import { FarmMapPage } from './farm-map.page';
import { GenericMapModule } from 'src/app/core/modules/generic-map.module';
import { SharedModule } from 'src/app/core/modules/shared.module';
import { MapFilterComponent } from './components/map-filter/map-filter.component';
import { TranslateModule } from '@ngx-translate/core';
import { FarmModule } from 'src/app/core/modules/farm.module';
import { AddImportFarmComponent } from './components/add-import-farm/add-import-farm.component';
import { ScoutingNoteInfoComponent } from './components/scouting-note-info/scouting-note-info.component';
import { AddScoutingNoteModalComponent } from './components/add-scouting-note-modal/add-scouting-note-modal.component';
import { MediaModule } from 'src/app/core/modules/media.module';
import { TimelinePreviewModule } from 'src/app/core/modules/timeline-preview.module';
import { AddScoutingInfoModalComponent } from './components/add-scouting-info-modal/add-scouting-info-modal.component';
import { MapFarmDetailComponent } from './components/map-farm-detail/map-farm-detail.component';
import { UnitPreferenceModule } from 'src/app/core/modules/unit-preferences.module';
import { IconModule } from 'src/app/core/modules/icon.module';
import { DeviceLocationInfoComponent } from './components/device-location-info/device-location-info.component';
import { PullupFooterModule } from 'src/app/core/helper/components/pullup-footer/pullup-footer.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    FarmMapPageRoutingModule,
    GenericMapModule,
    SharedModule,
    TranslateModule,
    FarmModule,
    MediaModule,
    TimelinePreviewModule,
    UnitPreferenceModule,
    IconModule,
    PullupFooterModule],
  declarations: [
    FarmMapPage,
    MapFilterComponent,
    AddImportFarmComponent,
    ScoutingNoteInfoComponent,
    AddScoutingNoteModalComponent,
    AddScoutingInfoModalComponent,
    MapFarmDetailComponent,
    DeviceLocationInfoComponent],
  exports: [
    DeviceLocationInfoComponent
  ]

})
export class FarmMapPageModule { }
